export const styles = {
  upgradeNow: {
    "& a": {
      padding: "4px",
    },
  },
};
